import { createTheme, styled } from '@mui/system';
import { emulatorScreen, laptopScreen, mobileScreen } from '../../utils/index.js';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Button, Typography, Grid } from "@mui/material";


// Create a theme instance
const theme = createTheme();
export default {
  Title: styled(Typography)({
    display: "flex",
    width: "100%",
    minHeight: 55,
    justifyContent: "center",
    alignItems: "center",
    fontSize: 32,
    letterSpacing: 1,
    color: "#003E4C",
    fontWeight: 600,
    fontFamily: "Oswald",
    lineHeight: 1.2,
    textAlign: "center",
    flexWrap: "wrap",
    [emulatorScreen(theme)]: {
      fontSize: 24,
    },
    [laptopScreen(theme)]: {
      fontSize: 22,
      minHeight: 44,
    },
    [mobileScreen(theme)]: {
      fontSize: 16,
      minHeight: 30,
    },
  }),

  QuestionMarkers: styled(QuestionMarkIcon)({
    fontSize: 16,
    fontWeight: 700,
    background: "#3b3b3b",
    borderRadius: "50%",
    color: "#fff",
    [emulatorScreen(theme)]: {
      fontSize: 14,
    },
    [mobileScreen(theme)]: {
      fontSize: 8,
    }
  }),


  ActualText: styled(Typography)({
    fontSize: 24,
    fontWeight: 700,
    fontFamily: "Rubik",
    color: "#003e4c",
    [emulatorScreen(theme)]: {
      fontSize: 20,
    },
    [mobileScreen(theme)]: {
      fontSize: 12,
    }
  }),

  ActualColor: styled(Typography)({
    height: 25,
    margin: 'auto',
    width: 50,
    marginLeft: 10,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 10,
      width: 22,
    }
  }),
  ScoreText: styled(Typography)({
    fontSize: 50,
    fontFamily: "Oswald",
    fontWeight: 700,
    color: '#003e4c',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 16
    }
  }),
  ScorePercentageContainer: styled(Grid)({
    width: "60%",
    height: '35%',
    margin: "2% 0%",
    fontFamily: "Oswald",
    backgroundColor: '#fff',
    fontWeight: 900,
    color: '#003e4c',
    alignItems: 'center',
    justifyContent: 'center',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: '23%',
    }
  }),
  ScorePercentage: styled(Typography)({
    fontSize: 110,
    fontWeight: 900,
    fontFamily: "Rubik",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 50
    }
  }),
  DescriptionText: styled(Typography)({
    fontSize: 15,
    fontFamily: "Rubik",
    color: '#003e4c',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 10,
    }
  }),

  // PercentageText: styled(Typography)({
  //   fontSize: 36,
  //   fontWeight: 800,
  //   fontFamily: "Oswald",
  //   marginRight: "10%",
  //   [emulatorScreen(theme)]: {
  //   },
  //   [mobileScreen(theme)]: {
  //     fontSize: 18
  //   }
  // }),

  NextButton: styled(Button)({
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "30px",
    fontWeight: "500",
    padding: "0px 20px",
    margin: "24px 0",
    borderRadius: "5px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 16,
      fontWeight: "500",
      padding: "0px 10px",
      margin: "5px 0",
    }
  }),

  GridMargin: styled(Grid)({
    marginTop: 32,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      marginTop: 5
    }
  }),
  GridHeight: styled(Grid)({
    height: 20,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 10
      // lineHeight: 0.5
    }
  }),

  AnswerCategory: styled(Typography)({
    fontFamily: "Rubik",
    color: "#003E4C",
    textAlign: 'end',
    paddingRight: 10,
    lineHeight: 1.2,
    fontSize: 14,
    [emulatorScreen(theme)]: {
      fontSize: 13,
    },
    [laptopScreen(theme)]: {
      fontSize: 12,
    },
    [mobileScreen(theme)]: {
      fontSize: 8,
      lineHeight: 0.9,
      minHeight: 30
    }
  }),

  SliderPercentage: styled(Typography)({
    paddingLeft: 5,
    color: "#003e4c",
    fontFamily: 'Rubik',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 10
    }
  })
}